import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=79fa347a&scoped=true&"
import script from "./categoryList.js?vue&type=script&lang=js&"
export * from "./categoryList.js?vue&type=script&lang=js&"
import style0 from "./categoryList.vue?vue&type=style&index=0&id=79fa347a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fa347a",
  null
  
)

export default component.exports